module.exports = __webpack_public_path__ + "media/images/placeholder__our-testing-philosophy-23ee984292f08369638241c102bd03a0.jpg";